import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { LOP_OVERTIME_REQUEST_URL } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const {
  GET_LOP_OVERTIME_REQUEST,
  POST_LOP_OVERTIME_REQUEST,
  PUT_LOP_OVERTIME_REQUEST,
  DELETE_LOP_OVERTIME_REQUEST
} = LOP_OVERTIME_REQUEST_URL;

export const lopAndOvertimeRequestApi = createApi({
  reducerPath: 'lopAndOvertimeRequestApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getLopOvertimeRequest: builder.query({
      query: (data) => ({
        url: `${GET_LOP_OVERTIME_REQUEST}${buildQueryString(data)}`,
        method: GET
      })
    }),
    addLopOvertimeRequest: builder.mutation({
      query: (data) => ({ url: POST_LOP_OVERTIME_REQUEST, method: POST, data })
    }),
    deleteLopOvertimeRequest: builder.mutation({
      query: (id) => ({
        url: `${DELETE_LOP_OVERTIME_REQUEST}/${id}`,
        method: DELETE
      })
    }),
    editLopOvertimeRequest: builder.mutation({
      query: (data) => ({
        url: `${PUT_LOP_OVERTIME_REQUEST}/${data.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const {
  useGetLopOvertimeRequestQuery,
  useAddLopOvertimeRequestMutation,
  useEditLopOvertimeRequestMutation,
  useDeleteLopOvertimeRequestMutation
} = lopAndOvertimeRequestApi;
